__turbopack_context__.v({
  "content": "MarkdownEditor-module__eF2yLW__content",
  "controlsGroup": "MarkdownEditor-module__eF2yLW__controlsGroup",
  "root": "MarkdownEditor-module__eF2yLW__root",
  "toolbar": "MarkdownEditor-module__eF2yLW__toolbar",
});
